import { useEffect } from "react";
import { APP_ADMIN_NAME, APP_NAME, PAGE_META } from "../constants/pageMeta";

const ensureMetaDescription = () => {
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
    }
    return tag;
};

const usePageMeta = (pageKey) => {
    useEffect(() => {
        const meta = PAGE_META[pageKey];
        if (!meta) return;

        const brand = meta.admin ? APP_ADMIN_NAME : APP_NAME;
        document.title = `${meta.title} | ${brand}`;
        ensureMetaDescription().setAttribute("content", meta.description);
    }, [pageKey]);
};

export default usePageMeta;
